import { render } from "./ListeLivreur.vue?vue&type=template&id=28ac65f6&ts=true"
import script from "./ListeLivreur.vue?vue&type=script&lang=ts"
export * from "./ListeLivreur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__